import { Injectable } from "@angular/core";
import { ApiService, AuthService, CollaboratorService, UserService, ValidatorService } from "./api/services";
import { AdminService } from "./api/services";

@Injectable({
    providedIn: "root",
})
export class ApiProvider {

    constructor(
        public readonly api: ApiService,
        public readonly auth: AuthService,
        public readonly user: UserService,
        public readonly collaborator: CollaboratorService,
        public readonly admin: AdminService,
        public readonly validator: ValidatorService,
    ) { }

}
